var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-white p-24 lg:p-[50px]" }, [
    _c("h3", {
      staticClass: "text-30 font-regular mb-24 text-brown-400",
      domProps: { innerHTML: _vm._s(_vm.title) }
    }),
    _vm._v(" "),
    _c(
      "div",
      _vm._l(_vm.items, function(item) {
        return _c("div", { key: item.id }, [
          _c(
            "header",
            {
              staticClass:
                "flex items-center gap-8 flex-row text-orange group pb-16 mb-16 border-b border-gray-200 w-full justify-between cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.handleOpenItem(item.id)
                }
              }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(item.post_title) +
                  "\n                "
              ),
              _vm.openItem === item.id
                ? _c("i", {
                    staticClass:
                      "far fa-minus text-16 text-brown-400 group-hover:scale-110 transition-all"
                  })
                : _c("i", {
                    staticClass:
                      "far fa-plus text-16 text-brown-400 group-hover:scale-110 transition-all"
                  })
            ]
          ),
          _vm._v(" "),
          _vm.openItem === item.id
            ? _c(
                "section",
                { staticClass: "pb-24" },
                [
                  _c("loader", {
                    staticClass: "h-[24px]",
                    attrs: { loading: _vm.loading }
                  }),
                  _vm._v(" "),
                  !_vm.loading
                    ? _c("div", {
                        staticClass: "text-brown-300 p-margin",
                        domProps: {
                          innerHTML: _vm._s(_vm.openFaq.content.rendered)
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }